export const parseFeatureFlag = (value, defaultValue = false) => {
  if (typeof value === 'boolean') return value;
  if (value == null || value === '') return defaultValue;
  return ['1', 'true', 'yes', 'on'].includes(
    String(value).trim().toLowerCase(),
  );
};

export const FEATURE_FLAGS = Object.freeze({
  deviceAnalyticsV2: parseFeatureFlag(
    import.meta.env?.VITE_DEVICE_ANALYTICS_V2_ENABLED,
  ),
});
